interface CameraIconProps {
  color?: string;
}

export const CameraIcon = ({ color = 'white' }: CameraIconProps) => (
  <svg width="16" height="16" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.375 3.875L12.5217 0.728333C12.5916 0.658496 12.6806 0.610946 12.7776 0.59169C12.8745 0.572433 12.975 0.582334 13.0663 0.620142C13.1576 0.65795 13.2356 0.721968 13.2906 0.804112C13.3455 0.886256 13.3749 0.98284 13.375 1.08167V8.66833C13.3749 8.76716 13.3455 8.86375 13.2906 8.94589C13.2356 9.02803 13.1576 9.09205 13.0663 9.12986C12.975 9.16767 12.8745 9.17757 12.7776 9.15831C12.6806 9.13905 12.5916 9.0915 12.5217 9.02167L9.375 5.875M1.875 9.375H7.875C8.27282 9.375 8.65436 9.21696 8.93566 8.93566C9.21696 8.65436 9.375 8.27282 9.375 7.875V1.875C9.375 1.47718 9.21696 1.09564 8.93566 0.81434C8.65436 0.533035 8.27282 0.375 7.875 0.375H1.875C1.47718 0.375 1.09564 0.533035 0.81434 0.81434C0.533035 1.09564 0.375 1.47718 0.375 1.875V7.875C0.375 8.27282 0.533035 8.65436 0.81434 8.93566C1.09564 9.21696 1.47718 9.375 1.875 9.375Z"
      stroke={color}
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
